import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const ExamOrderProvider = (props) => {
  const api = new API();
  const [examOrderCatList, setExamOrderCatList] = useState([]);
  const [examOrderSubCatList, setExamOrderSubCatList] = useState([]);
  const [examOrderCatListLoader, setExamOrderCatListLoader] = useState(false);
  const [examOrderSubCatListLoader, setOrderSubCatListLoader] = useState(false);
  const [examOrderTableFilter, setExamOrderTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [subCatOrderId, setSubCatOrderId] = useState("");
  const [examOrderList, setExamOrderList] = useState([]);
  const [examOrderListLoader, setExamOrderListLoader] = useState(false);
  const fetchExamOrderCatList = async () => {
    setExamOrderCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("examorder/categorylist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setExamOrderCatList(res?.data?.data);
        } else {
          setExamOrderCatList([]);
        }
        setExamOrderCatListLoader(false);
      }));
  }
  const fetchExamOrderSubCatList = async (cid) => {
    setOrderSubCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("examorder/subcategorylist", {
        category_id: cid
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setExamOrderSubCatList(res?.data?.data);
        } else {
          setExamOrderSubCatList([]);
        }
        setOrderSubCatListLoader(false);
      }));
  }
  const fetchExamOrderList = async (data) => {
    // alert(data)
    setExamOrderListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setSubCatOrderId(data?.subcategory_id);
      (await api.getAll("examorder/examtablelist_v3", {
        category_id: data?.category_id,
        subcategory_id: data?.subcategory_id,
        ...examOrderTableFilter
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setExamOrderList(res?.data?.data);
        } else {
          Widget.showMessage('error',err?.response?.data?.message);
          setExamOrderList([]);
        }
        setExamOrderListLoader(false);
      }));
  }

  const fetOrderExamSub = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "qbank"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }
  const fetOrderExamTopic = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "qbank"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }

   return (
    <Context.Provider value={{
      ...props,
      examOrderCatList, setExamOrderCatList,
      examOrderSubCatList, setExamOrderSubCatList,
      examOrderCatListLoader, setExamOrderCatListLoader,
      examOrderSubCatListLoader, setOrderSubCatListLoader,
      examOrderTableFilter, setExamOrderTableFilter,
      examOrderList, setExamOrderList,
      examOrderListLoader, setExamOrderListLoader,
      fetchExamOrderCatList,
      fetchExamOrderSubCatList,
      fetchExamOrderList,
      fetOrderExamSub,
      fetOrderExamTopic
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default ExamOrderProvider;

